


















import { defineComponent } from '@vue/composition-api'
// @ts-ignore next-line
import { codemirror as VueCodemirror } from 'vue-codemirror'
// @ts-ignore next-line
import DiffMatchPatch from 'diff-match-patch'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/yaml/yaml.js'
import 'codemirror/addon/merge/merge.js'
import 'codemirror/addon/merge/merge.css'
import 'codemirror/addon/display/fullscreen.js'
import 'codemirror/addon/display/fullscreen.css'

type SyntaxError = {
  line: number | string,
  start: number | string,
  end: number | string
  message: string
}

export default defineComponent({
  components: {
    VueCodemirror,
  },
  props: {
    value: {
      type: String as () => string,
      required: true,
    },
    orgValue: {
      type: String as () => string,
      required: true,
    },
    errors: {
      type: Array as () => SyntaxError[],
      default: () => [],
    },
  },
  data () {
    return {
      hoverErrorMessage: undefined,
      hoverErrorPosition: { left: 0, top: 0 },
    }
  },
  setup (props, { emit }) {
    // @ts-ignore next-line
    window.diff_match_patch = DiffMatchPatch
    // @ts-ignore next-line
    window.DIFF_DELETE = -1
    // @ts-ignore next-line
    window.DIFF_INSERT = 1
    // @ts-ignore next-line
    window.DIFF_EQUAL = 0

    const cmOptions = {
      value: props.value,
      origRight: null,
      orientation: 'b-a',
      orig: props.orgValue,
      connect: 'align',
      tabSize: 4,
      mode: 'text/yaml',
      lineNumbers: true,
      line: true,
      highlightDifferences: true,
      showDifferences: true,
      extraKeys: {
        F11: function (cm) {
          cm.setOption('fullScreen', !cm.getOption('fullScreen'))
        },
        Esc: function (cm) {
          if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false)
        },
      },
      gutters: [ 'CodeMirror-lint-markers' ],
    }

    function updateEditorValue (value: string) {
      emit('input', value)
    }

    return {
      cmOptions,
      updateEditorValue,
    }
  },
  computed: {
    editor () {
      return this.$refs.codemirrorEditor.cminstance
    },
  },
  watch: {
    errors: {
      handler: 'highlightErrors',
      deep: true,
    },
  },
  mounted () {
    this.highlightErrors(this.errors)
  },
  methods: {
    highlightErrors (errors: SyntaxError[]) {
      const doc = this.editor.getDoc()

      // Clear any existing error line markers
      doc.getAllMarks().forEach(mark => mark.clear())

      errors.forEach(error => {
        const line = (typeof error.line === 'string' ? parseInt(error.line) : error.line) - 1
        const start = (typeof error.start === 'string' ? parseInt(error.start) : error.start) - 1
        const end = (typeof error.end === 'string' ? parseInt(error.end) : error.end) - 1

        // Add error line markers
        const warningIcon = document.createElement('span')
        warningIcon.className = 'material-icons syntax-error-icon'
        warningIcon.innerText = 'warning'
        doc.setGutterMarker(line, 'CodeMirror-lint-markers', warningIcon)
        doc.markText({ line, ch: start }, { line, ch: end }, { className: 'syntax-error' })

        // Add hover event listener
        const self = this
        warningIcon.addEventListener('mouseover', event => {
          self.hoverErrorMessage = error.message
          self.hoverErrorPosition = {
            left: `${event.pageX + 30}px`,
            top: `${event.pageY - 40}px`,
          }
        })

        // Add mouseout event listener to clear the error message
        warningIcon.addEventListener('mouseout', () => {
          self.hoverErrorMessage = undefined
        })
      })
    },
  },
})
